import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";

// Validation Schema
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().min(8, "Password must be at least 8 characters").required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  gender: Yup.string().oneOf(["male", "female"], "Invalid gender").required("Gender is required"),
  terms: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required("You must accept the terms and conditions"),
  favoriteColor: Yup.string().required("Favorite color is required"),
  comments: Yup.string().max(200, "Comments must be 200 characters or less"),
});

const MyForm = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      gender: "",
      terms: false,
      favoriteColor: "",
      comments: "",
    },
    validationSchema,
    onSubmit: (values) => {},
  });

  return (
    <div className="mx-auto max-w-lg p-4">
      <form onSubmit={formik.handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-gray-700">
            Name:
          </label>
          <input
            id="name"
            name="name"
            type="text"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
          />
          {formik.touched.name && formik.errors.name ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.name}</div>
          ) : null}
        </div>

        <div>
          <label htmlFor="email" className="block text-gray-700">
            Email:
          </label>
          <input
            id="email"
            name="email"
            type="email"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.email}</div>
          ) : null}
        </div>

        <div>
          <label htmlFor="password" className="block text-gray-700">
            Password:
          </label>
          <input
            id="password"
            name="password"
            type="password"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.password}</div>
          ) : null}
        </div>

        <div>
          <label htmlFor="confirmPassword" className="block text-gray-700">
            Confirm Password:
          </label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirmPassword}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.confirmPassword}</div>
          ) : null}
        </div>

        <div>
          <span className="block text-gray-700">Gender:</span>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="gender"
                value="male"
                className="form-radio"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                checked={formik.values.gender === "male"}
              />
              <span className="ml-2">Male</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="gender"
                value="female"
                className="form-radio"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                checked={formik.values.gender === "female"}
              />
              <span className="ml-2">Female</span>
            </label>
          </div>
          {formik.touched.gender && formik.errors.gender ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.gender}</div>
          ) : null}
        </div>

        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="terms"
              className="form-checkbox"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              checked={formik.values.terms}
            />
            <span className="ml-2">I accept the terms and conditions</span>
          </label>
          {formik.touched.terms && formik.errors.terms ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.terms}</div>
          ) : null}
        </div>

        <div>
          <label htmlFor="favoriteColor" className="block text-gray-700">
            Favorite Color:
          </label>
          <select
            id="favoriteColor"
            name="favoriteColor"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.favoriteColor}
          >
            <option value="" label="Select a color" />
            <option value="red" label="Red" />
            <option value="green" label="Green" />
            <option value="blue" label="Blue" />
          </select>
          {formik.touched.favoriteColor && formik.errors.favoriteColor ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.favoriteColor}</div>
          ) : null}
        </div>

        <div>
          <label htmlFor="comments" className="block text-gray-700">
            Comments:
          </label>
          <textarea
            id="comments"
            name="comments"
            className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-md focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.comments}
          />
          {formik.touched.comments && formik.errors.comments ? (
            <div className="mt-1 text-sm text-red-600">{formik.errors.comments}</div>
          ) : null}
        </div>

        <button
          type="submit"
          className="w-full rounded-md bg-indigo-500 p-2 text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default MyForm;
